import { state } from "../state.js";
import { renderHead, renderRows } from "../dom/table.js";
import {
  createEventCommon,
  setEventCommon,
  createFastestLapSessionData,
  setFastestLapSession,
  createRankingCommon,
} from "./shared/raceLike.js";
import { buildLapRankingColumns } from "./shared/rankingColumns.js";

function createSessionData(sessionDiv) {
  const label = document.createElement("p");
  label.textContent = "Lap: ";
  sessionDiv.append(label);

  const remainingLaps = document.createElement("p");
  remainingLaps.id = "remainingLaps";
  remainingLaps.textContent = "0/0";
  sessionDiv.append(remainingLaps);

  createFastestLapSessionData(sessionDiv);
}

function setSessionData(data) {
  document.getElementById("remainingLaps").innerHTML = data.LapsCompleted + "/" + data.LapsTotal;
  setFastestLapSession(data);
}

function columnsFor(tableEntry) {
  return buildLapRankingColumns({
    multiClass: tableEntry.Classes.length > 1,
    includeAfterLeader: true,
    includeTotalTime: true,
  });
}

function createRankingHead() {
  for (const tableEntry of state.tableIdentifires) {
    const table = document.getElementById(tableEntry.tableId);
    renderHead(table, columnsFor(tableEntry));
  }
}

function updateRanking(data) {
  for (const tableEntry of state.tableIdentifires) {
    const table = document.getElementById(tableEntry.tableId);
    const ranking = data[tableEntry.Ranking].filter((row) => tableEntry.Classes.includes(row.Class));
    renderRows(table, columnsFor(tableEntry), ranking, "STN");
  }
}

export const raceHandlers = {
  createEvent: createEventCommon,
  setEvent: setEventCommon,
  createSessionData,
  setSessionData,
  createRanking: createRankingCommon,
  createRankingHead,
  updateRanking,
};
